import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { color } from 'highcharts';
import { isEmptyField } from 'src/app/main/shared/stock-chart-module/stock-chart/stock-chart-shared/stock-chart-shared-services/stock-chart-util.service';
import { environment } from 'src/environments/environment';
import { isNullOrUndefined } from 'util';

@Injectable({
  providedIn: 'root'
})
export class MonitorDashboardService {

  urlConst: any = environment.url.OBSERVED_API_URL

  constructor(private http: HttpClient) { }

  getHeirarchy(postData) {
    let url = this.urlConst + "locations/heirarchy";
    return this.http.post<any>(url, postData)
  }

  getTrendAnalyticsData(postData: any) {
    let url = this.urlConst + 'ndims/getNaturalDisasterTrendAnalytics';
    return this.http.post<any>(url, postData)
  }

  getDisasterDamageData(postData: any) {
    let url = this.urlConst + 'ndims/getDisasterDamageData';
    return this.http.post<any>(url, postData)
  }

  getDisasterTableData(postData: any) {
    let url = this.urlConst + 'ndims/getDisasterEventData';
    return this.http.post<any>(url, postData)
  }

  getPostDataForAPI(params: any) {
    let postData = {
      'disasterType': isNullOrUndefined(params.disasterType) ? 'Flood' : params.disasterType,
      "timeFormat": (isNullOrUndefined(params.year) || params.year == 'ALL') ? "Yearly" : "Monthly",
      "timePeriod": (isNullOrUndefined(params.year) || params.year == 'ALL') ? 'ALL' : params.year,
      "sourceType": params.source
    }
    return postData
  }

  getLineChartData(data): any {
    const chartOptions = {
      chart: {
        type: 'spline',
        backgroundColor: 'transparent',
        height: 300
      },
      title: {
        text: 'Trends & Analytics',
        style: { color: '#9aa2a7ff', fontSize: '16px', fontWeight: 'bold' }
      },
      xAxis: {
        categories: data.categories,
        // [
        //   'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        //   'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
        // ],
        title: {
          // text: 'Months',
          style: { color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif', }
        },
        labels: {
          style: { color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif', }
        },
        lineColor: '#888888',
        tickColor: '#888888'
      },
      yAxis: {
        title: {
          text: 'No. of Events',
          style: { color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif', }
        },
        labels: {
          style: { color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif', }
        },
        gridLineColor: '#666666'
      },
      legend: {
         layout: 'horizontal',
  align: 'center',
  verticalAlign: 'bottom',
  itemMarginTop: 4,
  itemMarginBottom: 4,
  symbolRadius: 0,
        itemStyle: { color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif',
            fontSize: '12px',
    fontWeight: 'normal'
           }
      },
      credits: { enabled: false },
      tooltip: {
        shared: true,
        valueSuffix: ' Events',
        backgroundColor: '#222',
        style: { color: '#fff' },
        headerFormat: '<b>{point.key}</b><br/>',
        pointFormat: '{point.y}<br/>'
      },
      plotOptions: {
        spline: {
          lineWidth: 2,
          color: '#1E90FF',
          marker: { enabled: false }
        }
      },
      series: [{
        type: 'spline',
        data: data.chartData//[5, 8, 6, 9, 14, 12, 10, 13, 15, 9, 6, 7]
      }]
    }
    return chartOptions
  }

  // getBarChartData(): any {
  //   const chartOptions = {
  //     chart: {
  //       type: 'column',
  //       backgroundColor: 'transparent',
  //       height: 300
  //     },
  //     title: {
  //       text: 'Intensity vs Damage',
  //       style: { color: '#ffffff', fontSize: '16px', fontWeight: 'bold' }
  //     },
  //     xAxis: {
  //       categories: [
  //         'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  //         'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  //       ],
  //       title: {
  //         // text: 'Months',
  //         style: { color: '#ffffff' }
  //       },
  //       labels: {
  //         style: { color: '#ffffff' }
  //       },
  //       lineColor: '#888888',
  //       tickColor: '#888888'
  //     },
  //     yAxis: {
  //       title: {
  //         text: 'Damage (%)',
  //         style: { color: '#ffffff' }
  //       },
  //       labels: {
  //         style: { color: '#ffffff' }
  //       },
  //       gridLineColor: '#666666'
  //     },
  //     legend: { enabled: false },
  //     credits: { enabled: false },
  //     tooltip: {
  //       shared: true,
  //       valueSuffix: ' locations',
  //       backgroundColor: '#222',
  //       style: { color: '#fff' }
  //     },
  //     plotOptions: {
  //       spline: {
  //         lineWidth: 2,
  //         color: '#1E90FF',
  //         marker: { enabled: false }
  //       }
  //     },
  //     series: [{
  //       type: 'column',
  //       data: [5, 8, 6, 9, 14, 12, 10, 13, 15, 9, 6, 7]
  //     }]
  //   }
  //   return chartOptions
  // }

  getBarChartData(chartData): any {
    const chartOptions = {
      chart: {
        type: 'column',
        backgroundColor: 'transparent',
        height: 300
      },
      title: {
        text: 'Intensity vs Damage',
        style: { color: '#ffffff', fontSize: '16px', fontWeight: 'bold' }
      },
      xAxis: {
        categories: chartData.categories,
        labels: {
          style: { color: '#ffffff' }
        },
        lineColor: '#888888',
        tickColor: '#888888'
      },
      // yAxis: {
      //   title: {
      //     text: 'Damage',
      //     style: { color: '#ffffff' }
      //   },
      //   labels: {
      //     style: { color: '#ffffff' }
      //   },
      //   gridLineColor: '#666666'
      // },
      yAxis: [{ // Primary yAxis
        gridLineWidth: 0,
        labels: {

          style: {
           color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif',
          }
        },
        title: {
          text: 'Intensity',
          style: {
            color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif',
          }
        }
      }, { // Secondary yAxis
        title: {
          text: 'Damage (INR)',
          style: {
            color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif',
          }
        },
        labels: {

          style: {
            color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif',
          }
        },
        opposite: true
      }],
      // legend: { enabled: false },
      legend: {
         layout: 'horizontal',
  align: 'center',
  verticalAlign: 'bottom',
  itemMarginTop: 4,
  itemMarginBottom: 4,
  symbolRadius: 0,
        itemStyle: { color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif',
            fontSize: '12px',
    fontWeight: 'normal'
           }
      },
      credits: { enabled: false },
      tooltip: {
        shared: true,
        backgroundColor: '#222',
        style: { color: '#fff' },
        // headerFormat: '<b>{point.key}</b><br/>',
        // pointFormat: '{series.name}: {point.y}<br/>'
        headerFormat: '<span style="font-size:13px"><b>{point.key}</b></span><br/>',
        pointFormat:
          '<span style="color:{series.color}">●</span> {series.name}: ' +
          '<b>{point.y}</b><br/>',
      },
      plotOptions: {
        column: {
          stacking: 'normal', // stacked columns
          dataLabels: {
            enabled: false,
            color: '#ffffff',
            style: { textOutline: 'none' }
          }
        }
      },
      series: chartData.chartSeries
    };
    return chartOptions;
  }

  formatChartResponse(params, that) {
    let response = that.damageChartData
    // {
    //   "202501": {
    //     "Total Deaths": 12,
    //     "No. Injured": 30,
    //     "No. Affected": 1055,
    //     "No. Homeless": 2332,
    //     "Total Damage (INR)": 2332
    //   },
    //   "202502": {
    //     "Total Deaths": 23,
    //     "No. Injured": 432,
    //     "No. Affected": 1213,
    //     "No. Homeless": 5332,
    //     "Total Damage (INR)": 2332
    //   },
    //   "202503": {
    //     "Total Deaths": 12,
    //     "No. Injured": 30,
    //     "No. Affected": 1055,
    //     "No. Homeless": 2332,
    //     "Total Damage (INR)": 2332
    //   },
    //   "202504": {
    //     "Total Deaths": 23,
    //     "No. Injured": 432,
    //     "No. Affected": 1213,
    //     "No. Homeless": 5332,
    //     "Total Damage (INR)": 1234
    //   },
    //   "202505": {
    //     "Total Deaths": 12,
    //     "No. Injured": 30,
    //     "No. Affected": 1055,
    //     "No. Homeless": 2332,
    //     "Total Damage (INR)": 980
    //   },
    //   "202506": {
    //     "Total Deaths": 23,
    //     "No. Injured": 432,
    //     "No. Affected": 1213,
    //     "No. Homeless": 5332,
    //     "Total Damage (INR)": 3409
    //   },
    //   "202507": {
    //     "Total Deaths": 12,
    //     "No. Injured": 30,
    //     "No. Affected": 1055,
    //     "No. Homeless": 2332,
    //     "Total Damage (INR)": 5543
    //   },
    //   "202508": {
    //     "Total Deaths": 23,
    //     "No. Injured": 432,
    //     "No. Affected": 1213,
    //     "No. Homeless": 5332,
    //     "Total Damage (INR)": 2213
    //   },
    //   "202509": {
    //     "Total Deaths": 12,
    //     "No. Injured": 30,
    //     "No. Affected": 1055,
    //     "No. Homeless": 2332,
    //     "Total Damage (INR)": 2332
    //   },
    //   "202510": {
    //     "Total Deaths": 23,
    //     "No. Injured": 432,
    //     "No. Affected": 1213,
    //     "No. Homeless": 5332,
    //     "Total Damage (INR)": 334
    //   },
    //   "202511": {
    //     "Total Deaths": 12,
    //     "No. Injured": 30,
    //     "No. Affected": 1055,
    //     "No. Homeless": 2332,
    //     "Total Damage (INR)": 2342
    //   },
    //   "202512": {
    //     "Total Deaths": 23,
    //     "No. Injured": 432,
    //     "No. Affected": 1213,
    //     "No. Homeless": 5332,
    //     "Total Damage (INR)": 2878
    //   },
    //   "Total": {
    //     "Total Deaths": 300,
    //     "No. Injured": 3231,
    //     "No. Affected": 12130,
    //     "No. Homeless": 53312,
    //     "Total Damage (INR)": 1234
    //   }
    // }

    const colors: any = {
      "Total Deaths": "#ff0000",
      "No. Injured": "orange",
      "No. Affected": "#00ffff",
      "No. Homeless": "green",
      "Total Damage (INR)": '#ffffff'
    };

    if (response && response['Total']) {
      that.stats = delete response['Total']['Total Damage (INR)']
      that.stats = response['Total']
    } else {
      that.stats = {}
    }

    // remove 'Total' key if not needed in chart
    let categories = Object.keys(response).filter(key => key !== "Total");

    const deathsData = categories.map(key => response[key]["Total Deaths"]);
    const injuredData = categories.map(key => response[key]["No. Injured"]);
    const affectedData = categories.map(key => response[key]["No. Affected"]);
    const homelessData = categories.map(key => response[key]["No. Homeless"]);
    const damageData = categories.map(key => response[key]["Total Damage (INR)"]);

    const chartSeries = [
      { name: "Total Affected", data: affectedData, color: colors["No. Affected"], type: 'column' },
      { name: "Total Injured", data: injuredData, color: colors["No. Injured"], type: 'column' },
      { name: "Total Deaths", data: deathsData, color: colors["Total Deaths"], type: 'column' },
      { name: "Total Homeless", data: homelessData, color: colors["No. Homeless"], type: 'column' },
      { name: "Total Damage (INR)", data: damageData, color: colors["Total Damage (INR)"], type: 'spline', yAxis: 1 }
    ];
    console.log("params:::", params);

    if (isNullOrUndefined(params.year) || params.year != 'All') {
      categories = this.getMonthNamesFromKeys(categories)
    }

    return { chartSeries, categories }
  }

  formatLineChartData(params: any, lineChartResponse: any) {
    // let lineChartResponse = {
    //   "200001": 350,
    //   "200502": 320,
    //   "201003": 420,
    //   "201204": 1120,
    //   "201505": 1102,
    //   "201706": 1210,
    //   "201807": 1310,
    //   "201909": 1210,
    //   "202110": 1390,
    //   "202211": 980,
    //   "202412": 890
    // }

    let categories = Object.keys(lineChartResponse)
    const chartData = categories.map(key => lineChartResponse[key])
    if (isNullOrUndefined(params.year) || params.year != 'All') {
      categories = this.getMonthNamesFromKeys(categories)
    }
    return { chartData, categories }
  }

  getMonthNamesFromKeys(keys: string[]): string[] {
    const monthMap: { [key: string]: string } = {
      "01": "Jan",
      "02": "Feb",
      "03": "Mar",
      "04": "Apr",
      "05": "May",
      "06": "Jun",
      "07": "Jul",
      "08": "Aug",
      "09": "Sep",
      "10": "Oct",
      "11": "Nov",
      "12": "Dec"
    };

    return keys.map(key => {
      const month = key.slice(4, 6); // extract month part (MM)
      return monthMap[month] || key; // fallback to original if not found
    });
  }

  formatNumberDynamic(value: number): string {
    if (value === null || value === undefined) return '';

    const units = ["", "K", "M", "B", "T", "P", "E"];
    let unitIndex = 0;

    while (value >= 1000 && unitIndex < units.length - 1) {
      value /= 1000;
      unitIndex++;
    }

    return value.toFixed(1).replace(/\.0$/, '') + units[unitIndex];
  }

  formatIndianNumber(value: number | string): string {
    if (!value && value !== 0) return "";

    const str = value.toString();
    const lastThree = str.slice(-3);
    const otherNumbers = str.slice(0, -3);

    if (otherNumbers !== '') {
      return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree;
    } else {
      return lastThree;
    }
  }

  deepClone(object: any): any {
    if (isEmptyField(object)) {
      return;
    }
    if (Array.isArray(object)) {
      return object.slice();
    }
    const cloneObj: any = {};
    const attributes = Object.keys(object);
    for (const attribute of attributes) {
      const property = object[attribute];

      if (typeof property === 'object') {
        cloneObj[attribute] = this.deepClone(property);
      } else {
        cloneObj[attribute] = property;
      }
    }
    return cloneObj;
  }

}
